import { TabPanel } from '@mui/lab';
import React from 'react';
import { TMaterialStyleItem, TMaterialStyles } from '../../theme';

interface ICustomTabPanel extends React.PropsWithChildren {
  value: string;
  sx?: TMaterialStyleItem;
}

export const CustomTabPanel: React.FC<ICustomTabPanel> = ({
  value,
  sx,
  children,
}) => {
  return (
    <TabPanel sx={[materialStyles.tabPanelContainer, sx || null]} value={value}>
      {children}
    </TabPanel>
  );
};

const materialStyles: TMaterialStyles = {
  tabPanelContainer: {
    margin: 0,
    padding: 0,
    mt: '4px',
  },
};
